import React from 'react';

const Card = (props) => {
  return <div className="bg-background p-4 w-screen h-screen">Card Screen</div>;
};

export default Card;
